require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-aol-content-hub-v-2.json") })
        }
      }, "path---projects-aol-content-hub-v-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-aol-content-hub-v-2!./.cache/json/projects-aol-content-hub-v-2.json
// module id = 352
// module chunks = 231608221292675